<template>
  <div>
      <Rectangle name="企业信息"   />   
    <div>
      <el-form :model="companyFormModel" ref="companyForm" :rules="rules">
      <el-table :data="tableDataComp" border :span-method="arraySpanMethod">
        <el-table-column
          v-if="!isDetail"
          width="55">
          <template slot-scope="scope">
            <el-checkbox
            :disabled="companyInfoCheckStatus[scope.row.dataProperty].checkDisabled"
            v-model="companyInfoCheckStatus[scope.row.dataProperty].checked"
            @change="checkCompanyInfo(scope.$index, scope.row)"
            v-if="scope.row.dataProperty!='creditCode' && scope.row.dataProperty!='compChangeReason'">
            </el-checkbox>
          </template>
        </el-table-column>

        <el-table-column
          prop="type"
          width="170"
          label="变更类别">
        </el-table-column>
        <el-table-column
          prop="origin"
          width="250"
          label="修改前信息">
          <template slot-scope="scope" >
            <el-input
              :disabled="isDetail"
              v-if="scope.row.dataProperty=='compChangeReason'"
              type="textarea"
              :rows="4"
              @input="inputInfo"
              maxlength="100"
              placeholder="请输入内容"
              v-model.trim="tableDataComp[scope.$index].changeto">
            </el-input>
            <span v-else-if="scope.row.dataProperty=='industryType'">{{getIndustryTypeName(tableDataComp[scope.$index].origin)}}</span>
            <span v-else-if="scope.row.dataProperty=='scale'">{{getComScaleName(tableDataComp[scope.$index].origin)}}</span>
            <span v-else-if="scope.row.dataProperty=='lawCertType'">{{getCertTypeName(tableDataComp[scope.$index].origin)}}</span>
            <span v-else-if="scope.row.dataProperty=='registerAddress'">
              <span>{{getArea(detail.origin.companyInfo)}}</span><br/>
              <span>{{scope.row.origin}}</span>
            </span>
            
            <span v-else>{{tableDataComp[scope.$index].origin}}</span>
            
          </template>
        </el-table-column>
        <el-table-column
          label="修改后信息">
          <template slot-scope="scope">
            <el-form-item :prop="scope.row.dataProperty">
              <el-select
                class="userinfo-input"
                v-if="scope.row.dataProperty=='industryType'"
                :disabled="!companyInfoCheckStatus[scope.row.dataProperty].checked"
                v-model.trim="tableDataComp[scope.$index].changeto"
              placeholder="请选择">
                <el-option
                  v-for="item in industryOptions"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id">
                </el-option>
              </el-select>
              <el-select
                class="userinfo-input"
                v-if="scope.row.dataProperty=='scale'"
                :disabled="!companyInfoCheckStatus[scope.row.dataProperty].checked"
                v-model.trim="tableDataComp[scope.$index].changeto"
              placeholder="请选择">
                <el-option
                  v-for="item in scaleOptions"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value">
                </el-option>
              </el-select>
              <el-select
                class="userinfo-input"
                v-if="scope.row.dataProperty=='lawCertType'"
                :disabled="!companyInfoCheckStatus[scope.row.dataProperty].checked"
                v-model="tableDataComp[scope.$index].changeto"
                placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-cascader
                  v-if="scope.row.dataProperty=='registerAddress'"
                  :disabled="!companyInfoCheckStatus[scope.row.dataProperty].checked"
                  class="full-width address-cascader"
                  size="large"
                  :props="{ expandTrigger: 'hover' }"
                  :options="area.regionData"
                  v-model="area.selectedOptions"
                  @change="handleCascaderChange"
                  placeholder="请选择注册地区">
              </el-cascader>
              <el-input  v-if="scope.row.dataProperty=='registerAddress'"
              :disabled="!companyInfoCheckStatus[scope.row.dataProperty].checked"
              v-model.trim="tableDataComp[scope.$index].changeto"
              class="userinfo-input company-address"/>
            <el-input
              v-if="  scope.row.dataProperty!='industryType' 
                    &&scope.row.dataProperty!='scale'
                    &&scope.row.dataProperty!='lawCertType'
                    &&scope.row.dataProperty!='registerAddress'
               "
              :disabled="scope.row.dataProperty!='compChangeReason' && !companyInfoCheckStatus[scope.row.dataProperty].checked"
              v-model.trim="tableDataComp[scope.$index].changeto"
              class="userinfo-input"/>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
      </el-form>
    </div>
  </div>
</template>

<script>
//import Step from '@/components/public/Element/Step.vue';
import { CERT_TYPE_LIST,COM_SCALE,getComScaleStr } from '@/utif/constant';
import { INDUSTRY_TYPE , getIndustryTypeStr } from '@/views/authentication/verify/subpage/industryType.js';
import { regionData, CodeToText } from '@/utif/element-china-area-data.js';

export default {
  props:['detail', 'isDetail'],
  data(){
    return{
      industryOptions: INDUSTRY_TYPE,
      options: CERT_TYPE_LIST,
      scaleOptions: COM_SCALE,
      tableDataComp:[
        {
          type:'企业名称',
          origin: this.detail.origin.companyInfo.companyName,
          changeto: this.detail.changeto.companyInfo.companyName,
          dataProperty:"companyName"
        },
        {
          type:'行业类别',
          origin:this.detail.origin.companyInfo.industryType,
          changeto: this.detail.changeto.companyInfo.industryType,
          dataProperty:"industryType"
        },
        {
          type:'企业规模',
          origin: this.detail.origin.companyInfo.scale,
          changeto: this.detail.changeto.companyInfo.scale,
          dataProperty:"scale"
        },
        {
          type:'统一社会信用代码',
          origin:this.detail.origin.companyInfo.creditCode,
          changeto: this.detail.changeto.companyInfo.creditCode,
          dataProperty:"creditCode"
        },
        {
          type:'法定代表人',
          origin: this.detail.origin.companyInfo.organizerName,
          changeto: this.detail.changeto.companyInfo.organizerName,
          dataProperty:"organizerName"
        },
        {
          type:'证件类型',
          origin: this.detail.origin.companyInfo.lawCertType,
          changeto: this.detail.changeto.companyInfo.lawCertType,
          dataProperty:"lawCertType"
        },
        {
          type:'证件号码',
          origin: this.detail.origin.companyInfo.lawCertNo,
          changeto: this.detail.changeto.companyInfo.lawCertNo,
          dataProperty:"lawCertNo"
        },
        {
          type:'法定代表人手机号',
          origin: this.detail.origin.companyInfo.organizerPhone,
          changeto: this.detail.changeto.companyInfo.organizerPhone,
          dataProperty:"organizerPhone"
        },
        {
          type:'注册地址',
          origin: this.detail.origin.companyInfo.registerAddress,
          changeto: this.detail.changeto.companyInfo.registerAddress,
          dataProperty:"registerAddress"
        },
        {
          type:'变更原因',
          origin:this.detail.origin.companyInfo.compChangeReason,
          changeto:this.detail.changeto.companyInfo.compChangeReason,
          dataProperty: "compChangeReason",
        }
      ],
      companyInfoCheckStatus: {
        companyName:{checked:false, checkDisabled:false},
        industryType:{checked:false, checkDisabled:false},
        scale:{checked:false, checkDisabled:false},
        creditCode:{checked:false, checkDisabled:false},
        organizerName:{checked:false, checkDisabled:false},
        lawCertType:{checked:false, checkDisabled:false},
        lawCertNo:{checked:false, checkDisabled:false},
        organizerPhone:{checked:false, checkDisabled:false},
        registerAddress:{checked:false, checkDisabled:false}
      },
      area:{
        selectedOptions: [],
        regionData: regionData,
        provinceCode: this.detail.changeto.companyInfo.provinceCode,
        provinceName: this.detail.changeto.companyInfo.provinceName,
        cityCode: this.detail.changeto.companyInfo.cityCode,
        cityName: this.detail.changeto.companyInfo.cityName,
        countyCode: this.detail.changeto.companyInfo.countyCode,
        countyName: this.detail.changeto.companyInfo.countyName,
      },
      rules: {
        companyName:[
          { validator: this.checkCompanyName, trigger: 'blur'}
        ],
        industryType:[
          { validator: this.checkIndustryType, trigger: 'blur'}
        ],
        scale:[
          { validator: this.checkScale, trigger: 'blur'}
        ],
        creditCode:[
          { validator: this.checkCreditCode, trigger: 'blur'}
        ],
        organizerName:[
          { validator: this.checkOrganizerName, trigger: 'blur'}
        ],
        lawCertType:[
          { validator: this.checkLawCertType, trigger: 'blur'}
        ],
        lawCertNo:[
          { validator: this.checkLawCertNo, trigger: 'blur'}
        ],
        organizerPhone:[
          { validator: this.checkOrganizerPhone, trigger: 'blur'}
        ],
        registerAddress:[
          { validator: this.checkRegisterAddress, trigger: 'blur'}
        ]
      }
    }
  },
  methods:{
    inputInfo (val) {
      console.log(val.length)
    },
    handleCascaderChange(val){
      this.$set(this.area, 'provinceName', CodeToText[val[0]]);// 省
      this.$set(this.area, 'cityName', CodeToText[val[1]]);// 市
      this.$set(this.area, 'countyName', CodeToText[val[2]]);// 区
      this.$set(this.area, 'provinceCode', val[0]);// 省
      this.$set(this.area, 'cityCode', val[1]);// 市
      this.$set(this.area, 'countyCode', val[2]);// 区
      // console.log(
      // this.CodeToText[val[0]],
      // this.CodeToText[val[1]],
      // this.CodeToText[val[2]],val)
    },
    getArea(companyInfo) {
      const area = [];
      if(companyInfo.provinceName) {
        area.push(companyInfo.provinceName);
      }
      if(companyInfo.cityName) {
        area.push(companyInfo.cityName);
      }
      if(companyInfo.countyName) {
        area.push(companyInfo.countyName);
      }

      return area.join(" / ");
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if(rowIndex==9){
        if(columnIndex==1 && this.isDetail){
          return [1,2];
        }

        if(columnIndex==2 && !this.isDetail){
          return [1,2];
        }
      }
    },
    saveFillInfo(){
      //debugger
      const companyInfo = {
        "companyName": this.tableDataComp[0].changeto,
        "industryType": this.tableDataComp[1].changeto,
        "scale": this.tableDataComp[2].changeto,
        "creditCode": this.tableDataComp[3].changeto,
        "organizerName": this.tableDataComp[4].changeto,
        "lawCertType": this.tableDataComp[5].changeto,
        "lawCertNo": this.tableDataComp[6].changeto,
        "organizerPhone": this.tableDataComp[7].changeto,
        "registerAddress": this.tableDataComp[8].changeto,
        "provinceCode": this.area.provinceCode,
        "provinceName": this.area.provinceName,
        "cityCode": this.area.cityCode,
        "cityName": this.area.cityName,
        "countyCode": this.area.countyCode,
        "countyName": this.area.countyName,
        "compChangeReason": this.tableDataComp[9].changeto
      };
      this.checkCompanyInfo();
      this.$emit('saveInfo', 'companyInfo', companyInfo);
    },
    checkCompanyInfo(index, row) {
      //let authFileStatus = this.$parent.companyAuthFileStatus;
      const changetoCompanyDetail = this.detail.changeto.companyInfo;
      const originCompanyDetail = this.detail.origin.companyInfo;
      //this.companyInfoCheckStatus[row.dataProperty].disabled = !this.companyInfoCheckStatus[row.dataProperty].checked;
      if(index == 0) {
        if(this.companyInfoCheckStatus["companyName"].checked) {
          if(originCompanyDetail.companyName == changetoCompanyDetail.companyName) {
            this.tableDataComp[0].changeto  = "";
          }
        } else {
          this.tableDataComp[0].changeto = changetoCompanyDetail.companyName;
        }
      };
      if(index == 1) {
        if(this.companyInfoCheckStatus["industryType"].checked) {
          if(originCompanyDetail.industryType == changetoCompanyDetail.industryType) {
            this.tableDataComp[1].changeto  = "";
          }
        } else if(originCompanyDetail.industryType == '1014'){
          this.tableDataComp[1].changeto  = "";
        } else {
          this.tableDataComp[1].changeto  = changetoCompanyDetail.industryType;
        }
      }
      if(index == 2) {
        if(this.companyInfoCheckStatus["scale"].checked) {
          if(originCompanyDetail.scale == changetoCompanyDetail.scale) {
            this.tableDataComp[2].changeto  = "";
          }
        } else {
          this.tableDataComp[2].changeto  = changetoCompanyDetail.scale;
        }
      }
      if(index == 3) {
        if(this.companyInfoCheckStatus["creditCode"].checked) {
          if(originCompanyDetail.creditCode == changetoCompanyDetail.creditCode) {
            this.tableDataComp[3].changeto  = "";
          }
        } else {
          this.tableDataComp[3].changeto  = changetoCompanyDetail.creditCode;
        }
      }
      if(index == 4) {
        if(this.companyInfoCheckStatus["organizerName"].checked) {
          if(originCompanyDetail.organizerName == changetoCompanyDetail.organizerName) {
            this.tableDataComp[4].changeto  = "";
          }
          
        //1, 1)勾选姓名，证件姓名，证件号码，手机号码默认都勾选
          this.companyInfoCheckStatus["lawCertType"].checked = true;
          this.companyInfoCheckStatus["lawCertType"].checkDisabled = true;
          if(originCompanyDetail.lawCertType == changetoCompanyDetail.lawCertType) {
            this.tableDataComp[5].changeto = "0";
          }
          

          this.companyInfoCheckStatus["lawCertNo"].checked = true;
          this.companyInfoCheckStatus["lawCertNo"].checkDisabled = true;
          if(originCompanyDetail.lawCertNo == changetoCompanyDetail.lawCertNo) {
            this.tableDataComp[6].changeto  = "";
          }
          
        } else {
          this.tableDataComp[4].changeto  = changetoCompanyDetail.organizerName;
        //1, 1)勾选姓名，证件姓名，证件号码，手机号码默认都勾选
          this.companyInfoCheckStatus["lawCertType"].checked = false;
          this.companyInfoCheckStatus["lawCertType"].checkDisabled = false;
          this.tableDataComp[5].changeto  = changetoCompanyDetail.lawCertType;

          this.companyInfoCheckStatus["lawCertNo"].checked = false;
          this.companyInfoCheckStatus["lawCertNo"].checkDisabled = false;
          this.tableDataComp[6].changeto  = changetoCompanyDetail.lawCertNo;
        }
      }
      //1. 2)单选证件类型， 证件号码选项框默认勾选且置灰
      if(index ==5) {
        if(this.companyInfoCheckStatus["lawCertType"].checked) {
          if(originCompanyDetail.lawCertType == changetoCompanyDetail.lawCertType) {
            this.tableDataComp[5].changeto  = "0";
          }
          
          this.companyInfoCheckStatus["lawCertNo"].checked = true;
          this.companyInfoCheckStatus["lawCertNo"].checkDisabled = true;
          if(originCompanyDetail.lawCertNo == changetoCompanyDetail.lawCertNo) {
            this.tableDataComp[6].changeto  = "";
          }
        } else {
          this.tableDataComp[5].changeto  = changetoCompanyDetail.lawCertType;

          this.companyInfoCheckStatus["lawCertNo"].checked = false;
          this.companyInfoCheckStatus["lawCertNo"].checkDisabled = false;
          this.tableDataComp[6].changeto  = changetoCompanyDetail.lawCertNo;
        }
      }

      if(index == 6) {
        if(this.companyInfoCheckStatus["lawCertNo"].checked) {
          if( originCompanyDetail.lawCertNo == changetoCompanyDetail.lawCertNo) {
            this.tableDataComp[6].changeto  = "";
          } 
        } else {
          this.tableDataComp[6].changeto  = changetoCompanyDetail.lawCertNo;
        }
      }

      if(index == 7) {
        if(this.companyInfoCheckStatus["organizerPhone"].checked) {
          if(originCompanyDetail.organizerPhone == changetoCompanyDetail.organizerPhone) {
            this.tableDataComp[7].changeto  = "";
          }
        } else {
          this.tableDataComp[7].changeto  = changetoCompanyDetail.organizerPhone;
        }
      }

      if(index == 8) {
        if(this.companyInfoCheckStatus["registerAddress"].checked) {
          if(originCompanyDetail.registerAddress == changetoCompanyDetail.registerAddress) {
            this.tableDataComp[8].changeto  = "";
          }
        } else {
          this.tableDataComp[8].changeto  = changetoCompanyDetail.registerAddress;
        }
      }

      //debugger
      //this.getCompanyInfoFileTableData();
      this.checkAuthFileStatus();
      if(this.$refs["companyForm"]) {
        this.$refs["companyForm"].clearValidate();
      }
    },
    checkAuthFileStatus() {
      let authFileStatus = {
          authFile: {visible: false},
          certFaceId: {visible: false},
          businessLicenceId: {visible: false},
          lawCertFaceId:{visible:false},
          allowChangeNoticeId: {visible: false},
          issueAgreement: {visible: false}
      };

      if(this.companyInfoCheckStatus["companyName"].checked ||
        this.companyInfoCheckStatus["creditCode"].checked
      ) {
          authFileStatus.authFile.visible = true;
          authFileStatus.certFaceId.visible = true;
          authFileStatus.businessLicenceId.visible = true;
          authFileStatus.lawCertFaceId.visible = true;
          authFileStatus.allowChangeNoticeId.visible = true;
      }
      if(this.companyInfoCheckStatus["organizerName"].checked) {
          authFileStatus.authFile.visible = true;
          //this.companyInfoFileStatus.certFaceId.visible = true;
          authFileStatus.businessLicenceId.visible = true;
          authFileStatus.lawCertFaceId.visible = true;
      };

      if(this.companyInfoCheckStatus["lawCertType"].checked ||
          this.companyInfoCheckStatus["lawCertNo"].checked) {
          authFileStatus.authFile.visible = true;
          //this.companyInfoFileStatus.certFaceId.visible = true;
          //this.authFileStatus.businessLicenceId.visible = true;
          authFileStatus.lawCertFaceId.visible = true;
      };

      if(this.companyInfoCheckStatus["industryType"].checked) {
          authFileStatus.authFile.visible = true;
          //this.companyInfoFileStatus.certFaceId.visible = true;
          //this.companyInfoFileStatus.businessLicenceId.visible = true;
          //this.companyInfoFileStatus.lawCertFaceId.visible = true;
      };

      if(this.companyInfoCheckStatus["registerAddress"].checked) {
          //this.companyInfoFileStatus.authFile.visible = true;
          //this.companyInfoFileStatus.certFaceId.visible = true;
          authFileStatus.businessLicenceId.visible = true;
          //this.companyInfoFileStatus.lawCertFaceId.visible = true;
      };

      this.$parent.companyAuthFileStatus = authFileStatus;
    },
    getIndustryTypeName(industryType) {
      return getIndustryTypeStr(industryType);
      // let industryTypeItems = INDUSTRY_TYPE.filter(industryTypeItem => industryTypeItem.id == industryType);
      // if(industryTypeItems.length > 0) {
      //   return industryTypeItems[0].name;
      // }

      // return industryType;
    },
    getComScaleName(type) {
      return getComScaleStr(type)
    },
    getCertTypeName(certType) {
      //debugger
      let certItems = CERT_TYPE_LIST.filter(certItem => certItem.value == certType);
      if(certItems.length > 0) {
        return certItems[0].label;
      }

      return certType;
    },
    checkCompanyName(rule, value, callback) {
      if(!this.tableDataComp[0].changeto) {
        return callback(new Error("请输入企业名称"));
      }
      callback();
    },
    checkIndustryType(rule, value, callback) {
      if(!this.tableDataComp[1].changeto) {
        return callback(new Error("请选择行业类别"));
      }
      callback();
    },
    checkScale(rule, value, callback) {
      if(!this.tableDataComp[2].changeto) {
        return callback(new Error("请选择企业规模"));
      }
      callback();
    },
    checkCreditCode(rule, value, callback) {
      if(!this.tableDataComp[3].changeto) {
        return callback(new Error("请输入全国社会信用代码"));
      }
      callback();
    },
    checkOrganizerName(rule, value, callback) {
      if(!this.tableDataComp[4].changeto) {
        return callback(new Error("请输入法定代表人"));
      }
      callback();
    },
    checkLawCertType(rule, value, callback) {
      if(!this.tableDataComp[5].changeto) {
        return callback(new Error("请选择证件类型"));
      }
      callback();
    },
    checkLawCertNo(rule, value, callback) {
      if(!this.tableDataComp[6].changeto) {
        return callback(new Error("请输入证件号码"));
      }
      callback();
    },
    checkOrganizerPhone(rule, value, callback) {
      const newValue = this.tableDataComp[7].changeto;
      if (newValue) {
        let reg = /^1\d{10}$/;
        if (!reg.test(newValue)) {
          return callback(new Error("请输入正确的手机号码"));
        }
      } 
      // 法人手机号非必输
      // else {
      //   return callback(new Error("请输入手机号"));
      // }
      callback();
    },
    checkRegisterAddress(rule, value, callback) {
      if(!this.tableDataComp[8].changeto) {
        return callback(new Error("请输入注册地址"));
      }
      callback();
    },
    inputValidate() {
      let validatePass = true;
      const companyForm = this.$refs.companyForm;
       if(companyForm) {
         companyForm.validate((valid) => {
           validatePass = valid;
         });
       }
       return validatePass;
    },
  },
  computed: {
    companyFormModel: function(){
      return {
      companyName: this.tableDataComp[0].changeto,
      industryType: this.tableDataComp[1].changeto,
      scale: this.tableDataComp[2].changeto,
      creditCode: this.tableDataComp[3].changeto,
      organizerName: this.tableDataComp[4].changeto,
      certType: this.tableDataComp[5].changeto,
      certNo  : this.tableDataComp[6].changeto,
      organizerPhone: this.tableDataComp[7].changeto,
      registerAddress: this.tableDataComp[8].changeto
      }
    },
    hasAnyChanged() {
      let hasAnyChange = false;
      //排除修改原因
      for(let i = 0; i < this.tableDataComp.length-1; i++) {
        let item = this.tableDataComp[i];
        if(item.changeto != this.detail.changeto.companyInfo[item.dataProperty]) {
          hasAnyChange = true;
          break;
        }
      }
      return hasAnyChange;
    }
  },
  mounted(){
    //this.initTableData();
    this.area.selectedOptions = [];
    if(this.detail.changeto.companyInfo.provinceCode) {
      this.area.selectedOptions.push(this.detail.changeto.companyInfo.provinceCode);
    }

    if(this.detail.changeto.companyInfo.cityCode) {
      this.area.selectedOptions.push(this.detail.changeto.companyInfo.cityCode);
    }

    if(this.detail.changeto.companyInfo.countyCode) {
      this.area.selectedOptions.push(this.detail.changeto.companyInfo.countyCode);
    }
    if(!this.isDetail) {
      for(let i=0; i<this.tableDataComp.length-1;i++) {
        //scale 没值时强制补充
        //industryType 行业类别为1014其它行业时 强制修改
        if(this.tableDataComp[i].origin != this.tableDataComp[i].changeto ||
           this.tableDataComp[i].dataProperty=='scale' && !this.tableDataComp[i].origin ||
           this.tableDataComp[i].dataProperty=='industryType' && this.tableDataComp[i].origin =='1014' ) {
          const dataProperty = this.tableDataComp[i].dataProperty;
          this.companyInfoCheckStatus[dataProperty].checked = true;
          this.checkCompanyInfo(i);
        }
      }
    }else{
      this.industryOptions.push( { id: '1014', name: '其他行业' });
    }
  }
}
</script>

<style lang="less" scoped>
  .userinfo-input{
    width: 400px;
    margin-right: 10px;
  }
  /deep/ .company-address {
    width: 100%;
  }
  /deep/ .address-cascader {
    width: 400px;
  }
  .ml20{
    margin-left: 20px;
  }
   .tc{
   text-align: center;
 }
 /deep/ .mr10{
   margin-right: 10px;
 }
 .mt50{
   margin-top: 50px;
 }

  /deep/ .error-msg {
   color: red ;
  }
  /deep/ .el-form-item {
      margin-bottom: 0;
      .el-form-item__error {
        position:relative;
        display: inline-block;
      }
  }
</style>